import useMobile from 'hooks/common/use-mobile';
import { useCallback, useEffect, useState } from 'react';

/**
 * Returns padding value and shouldApplyPadding function to use with product cards in a product grid.
 */
const useBestsellerStyleProperties = ({
  bestsellerProductsLength,
}): {
  paddingValue: number;
  shouldApplyPadding: (index: number) => boolean;
} => {
  const isMobile = useMobile();
  const [bestSellerWrapperMessageHeight, setBestSellerWrapperMessageHeight] =
    useState<number | null>(null);

  useEffect(() => {
    const element = document.getElementById('bestSellerWrapperMessage');
    if (element) {
      setBestSellerWrapperMessageHeight(element.offsetHeight);
    }

    return () => {
      setBestSellerWrapperMessageHeight(null);
    };
  }, [bestsellerProductsLength]);

  const shouldApplyPadding = useCallback(
    (index: number) => {
      return Boolean(
        !isMobile &&
          bestSellerWrapperMessageHeight &&
          ((bestsellerProductsLength === 1 && index < 2) ||
            (bestsellerProductsLength === 2 && index < 1) ||
            (bestsellerProductsLength === 3 && index < 0))
      );
    },
    [bestsellerProductsLength, bestSellerWrapperMessageHeight, isMobile]
  );

  const paddingValue = bestSellerWrapperMessageHeight
    ? // 16px is the padding between the bestseller message and the product cards
      bestSellerWrapperMessageHeight + 24
    : 0;

  return {
    paddingValue,
    shouldApplyPadding,
  };
};

export default useBestsellerStyleProperties;
